import { render, staticRenderFns } from "./CustomerListAddEditModal.vue?vue&type=template&id=0a8b1c2e&scoped=true"
import script from "./CustomerListAddEditModal.vue?vue&type=script&lang=js"
export * from "./CustomerListAddEditModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerListAddEditModal.vue?vue&type=style&index=0&id=0a8b1c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b1c2e",
  null
  
)

export default component.exports